export default __webpack_public_path__ + "static/media/Logo Group Dark.d96590f6.svg";